import { render } from "./OrderFormCreateUpdate.vue?vue&type=template&id=d0282844"
import script from "./OrderFormCreateUpdate.vue?vue&type=script&lang=js"
export * from "./OrderFormCreateUpdate.vue?vue&type=script&lang=js"

import "./OrderFormCreateUpdate.vue?vue&type=style&index=0&id=d0282844&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__